module.exports = __webpack_public_path__ + "static/media/girl-12.6bee401b.svg";